import { Navigate, Outlet } from 'react-router-dom';
import useAuthToken, { getUserRole } from './hooks/getUserData';

export default function PrivateRoutes() {
  const token = useAuthToken();

  const isAdmin = () => {
    if (token) {
      const role = getUserRole();
      if (role === '"admin"') {
        return true;
      }
      return false;
    }
    return false;
  };

  return isAdmin() ? <Outlet /> : <Navigate to="/unauthorized" />;
}
